import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { Store } from '@ngxs/store';
import { OrderItemComponent } from '@x/ecommerce-shop/app/core/order/components/order-item/order-item.component';
import {
  IShopOrderItemView,
  OrderItemViewService,
} from '@x/ecommerce-shop/app/core/order/services/order-item-view.service';
import { RegionOpenOverlay } from '@x/ecommerce-shop/app/core/region/state/region.actions';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IShopOrder } from '@x/ecommerce/shop-client';
import { OrderItemSource } from '@x/schemas/ecommerce';

@Component({
  selector: 'x-order-summary',
  templateUrl: './order-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-order-summary' },
  standalone: true,
  imports: [NgTemplateOutlet, NgIf, MatAnchor, UtilsModule, OrderItemComponent, NgForOf],
})
export class OrderSummaryComponent {
  private _order: IShopOrder;

  promoItems: IShopOrderItemView[] = [];
  outOfStockOrderItems: IShopOrderItemView[] = [];
  unlistedOrderItems: IShopOrderItemView[] = [];
  unavailableOrderItems: IShopOrderItemView[] = [];
  availableItems: IShopOrderItemView[] = [];

  @Input() set order(order: IShopOrder | undefined | null) {
    this.resetArrays();

    if (order) {
      this._order = order;

      const orderItems = this.orderItemViewService.makeList(order.items);

      orderItems.forEach((i) => {
        if (
          i.availabilityView?.status === 'AVAILABLE' &&
          (i.source === OrderItemSource.Order || i.source === 'SUBSCRIPTION')
        ) {
          this.availableItems.push(i);
        } else if (i.availabilityView?.status === 'UNAVAILABLE') {
          this.unavailableOrderItems.push(i);
        } else if (i.availabilityView?.status === 'UNLISTED') {
          this.unlistedOrderItems.push(i);
        } else if (i.availabilityView?.status === 'OUT_OF_STOCK') {
          this.outOfStockOrderItems.push(i);
        } else if (i.source === OrderItemSource.Promotional) {
          this.promoItems.push(i);
        }
      });
    }
  }

  @HostBinding('class')
  @Input()
  mode: 'compact' | 'expanded' = 'compact';

  get order() {
    return this._order;
  }

  constructor(
    private orderItemViewService: OrderItemViewService,
    private store: Store,
  ) {}

  openRegionOverlay() {
    this.store.dispatch(new RegionOpenOverlay());
  }

  private resetArrays() {
    this.promoItems = [];
    this.outOfStockOrderItems = [];
    this.unlistedOrderItems = [];
    this.unavailableOrderItems = [];
    this.availableItems = [];
  }
}
